import React from 'react';
import { Link } from 'react-router-dom';
import { HITLAB_PROFILE_READY_HOME_PATH } from './hitLabProfileReady';

const proofChips = [
  'Artist profile saved',
  'JG Player account ready',
  'Payment not started',
  'Record not in review yet',
];

export default function HitLabProfileReadyBridge({
  artistName = '',
  busy = false,
  onContinuePayment,
  onEditProfile,
  onUniverseClick,
  paymentPriceDisplay = '$9.99',
}) {
  const safeArtistName = String(artistName || '').trim();
  const artistLine = safeArtistName
    ? `${safeArtistName}, your JG Profile is started.`
    : 'Your JG Profile is started.';

  return (
    <section
      className="hitlab-form hitlab-profile-ready-bridge"
      aria-label="Profile Ready JG Universe bridge"
    >
      <div className="hitlab-post-submit-bridge-header">
        <div>
          <p className="hitlab-kicker">PROFILE READY</p>
          <h2>Your JG Profile is started. Your record is at the gate.</h2>
          <p>
            {artistLine} Complete the HitLab step to put your song in the
            pipeline.
          </p>
        </div>
        <Link
          className="hitlab-primary-btn"
          to={HITLAB_PROFILE_READY_HOME_PATH}
          onClick={onUniverseClick}
        >
          Enter JG Universe
        </Link>
      </div>

      <div className="hitlab-post-submit-proof-wrap">
        <p className="hitlab-post-submit-proof-label">Your current path</p>
        <ul
          className="hitlab-post-submit-proof"
          aria-label="HitLab profile ready proof"
        >
          {proofChips.map((chip) => (
            <li key={chip}>{chip}</li>
          ))}
        </ul>
      </div>

      <div className="hitlab-profile-ready-offers" aria-label="Profile ready next steps">
        <Link
          className="hitlab-profile-ready-offer"
          to={HITLAB_PROFILE_READY_HOME_PATH}
          onClick={onUniverseClick}
        >
          <span className="hitlab-profile-ready-eyebrow">JOE GALAXY RADIO</span>
          <strong>Hear Joe Galaxy Radio</strong>
          <span>
            Joe Galaxy Radio is live inside JG Universe.
          </span>
          <span>
            Hear records in rotation, see the artists behind them, and watch
            real listener activity and feedback take shape across the platform.
          </span>
          <span className="hitlab-profile-ready-offer-cta">
            Enter JG Universe + Hear Radio
          </span>
        </Link>

        <button
          type="button"
          className="hitlab-profile-ready-offer hitlab-profile-ready-offer-payment"
          disabled={busy}
          onClick={onContinuePayment}
        >
          <span className="hitlab-profile-ready-eyebrow">
            FOUNDING ARTIST RATE
          </span>
          <strong>Put the record in the Lab</strong>
          <span className="hitlab-profile-ready-price">
            One-time HitLab processing: {paymentPriceDisplay}
          </span>
          <span>
            This is the serious filter: one record, rights review, JG Radio
            consideration, listener reaction, support signal, and earned next
            moves when the record proves it.
          </span>
          <span>
            No fake streams. No fake praise. No guaranteed placement.
          </span>
          <span>
            If you believe this is the record, do not leave it sitting at the
            gate.
          </span>
          <span className="hitlab-profile-ready-boundary">
            Processing gets the record heard. Placement cannot be bought. The
            record has to earn the next move.
          </span>
          <span className="hitlab-profile-ready-offer-cta">
            {busy ? 'Opening payment' : 'Put My Record In The Lab'}
          </span>
        </button>
      </div>

      <button
        type="button"
        className="hitlab-profile-ready-edit"
        onClick={onEditProfile}
      >
        Edit Artist Profile
      </button>
    </section>
  );
}
